import { render, staticRenderFns } from "./EditCostPricesConsignorPrice.vue?vue&type=template&id=2e3296da&scoped=true"
import script from "./EditCostPricesConsignorPrice.vue?vue&type=script&lang=js"
export * from "./EditCostPricesConsignorPrice.vue?vue&type=script&lang=js"
import style0 from "./EditCostPricesConsignorPrice.vue?vue&type=style&index=0&id=2e3296da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3296da",
  null
  
)

export default component.exports